import { InfiniteData } from '@tanstack/react-query';
import { PaginationResponseType } from '@/common/types/ApiResponseTypes.type.ts';
import { FullFileType } from '@/modules/FileList/types/FileList.type.ts';
import myFilesDetailCardDefaultDataGenerator from '@/modules/FileList/data/detailCardList/myFilesDetailCardDefaultDataGenerator.ts';
import { myFilesDetailCardActionsGenerator } from '@/modules/FileList/data/detailCardList/myFilesDetailCardActionsGenerator.ts';

export const myFilesListDefaultSelectFunction = (
  data: InfiniteData<PaginationResponseType<FullFileType[]>, number>,
) => {
  return {
    ...data,
    pages: data.pages.map((page) => {
      return {
        ...page,
        results: page.results.map((item) => ({
          ...item,
          detailCardItems: myFilesDetailCardDefaultDataGenerator(item),
          action: myFilesDetailCardActionsGenerator(item),
        })),
      };
    }),
  };
};

export type MyFilesListDataType = ReturnType<
  typeof myFilesListDefaultSelectFunction
>;
